
import { Component, Vue, Prop} from 'vue-property-decorator';

import Form6ProcessHeader from "@/components/process/Form6/components/Form6ProcessHeader.vue";
import { form6StatusInfoType } from '@/types/Information/Form6';

@Component({
    components:{
        Form6ProcessHeader
    }
})
export default class ErrorSubmitForm6 extends Vue {
    
    @Prop({required: true, default:" "})
    errMsg!: string;

    stepsCompleted = {} as form6StatusInfoType;  
    mountedData = false;     

    mounted() {
        this.mountedData = false;        

        this.stepsCompleted = {
            first: true,
            second: true,
            third: false,
            thirdError:true
        }
        this.mountedData = true;                   
    }    

    public done() {
        this.$router.push({name: "dashboard" }) 
    }

    public contactUs(){
        const ContactButton = document.getElementsByName("contact-us");
        if(ContactButton[0]) ContactButton[0].click()
    }
}
